import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Button, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import NumberField from '../../../../components/forms/NumberField'
import Select from 'components/forms/Select'
import Checkbox from 'components/forms/Checkbox'
import DtoManagementUnitStationLink from '../dto/DtoManagementUnitStationLink'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { shallowEqual, useSelector } from 'react-redux'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'

const VolumesManagementUnitDialog = ({
    linkStationToUpdate,
    openDialog,
    onChange = () => { },
    validUpdate = () => { },
    closeDialog = () => { },
}) => {
    const { stationType, stationId, real, coeffReal, previ, coeffPrevi } = linkStationToUpdate
    const {
        piezometersLight,
        hydrometricStations,
        pluviometers,
    } = useSelector(store => ({
        piezometersLight: store.PiezometryReducer.piezometersLight,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        pluviometers: store.PluviometryReducer.pluviometers,
    }), shallowEqual)

    const getListStations = () => {
        switch (stationType) {
            case STATION_TYPE_CONSTANT.PIEZOMETRY:
                return piezometersLight.map((s) => ({ ...s, nameWithCode: `[${s.code || ''}] ${s.name || ''}` }))
            case STATION_TYPE_CONSTANT.HYDROMETRY:
                return hydrometricStations.map((s) => ({ ...s, nameWithCode: `[${s.code || ''}] ${s.name || ''}` }))
            case STATION_TYPE_CONSTANT.PLUVIOMETRY:
                return pluviometers.map((s) => ({ ...s, nameWithCode: `[${s.code || ''}] ${s.name || ''}` }))
            default:
                return []
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            onClose={closeDialog}
            open={openDialog}
        >
            <DefaultDialogTitle title={i18n.editAssociatedStations} onClose={closeDialog}/>
            <DialogContent>
                <Grid container spacing={1} alignItems='center'>
                    <Grid size={6}>
                        <Select
                            label={i18n.type}
                            options={[{
                                value: STATION_TYPE_CONSTANT.PIEZOMETRY,
                                label: i18n.piezometry,
                            }, {
                                value: STATION_TYPE_CONSTANT.HYDROMETRY,
                                label: i18n.hydrometry,
                            }, {
                                value: STATION_TYPE_CONSTANT.PLUVIOMETRY,
                                label: i18n.pluviometry,
                            }]}
                            value={stationType}
                            onChange={(value) => onChange({
                                stationType: value,
                                stationId: null,
                                ...(value !== STATION_TYPE_CONSTANT.PLUVIOMETRY ? {
                                    real: false,
                                    coeffReal: null,
                                    previ: false,
                                    coeffPrevi: null,
                                } : {}),
                            })}
                            noNullValue
                            obligatory
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={i18n.station}
                            options={getListStations()}
                            value={stationId}
                            keyValue='id'
                            keyLabel='nameWithCode'
                            onChange={(value) => onChange({ stationId: value })}
                            noNullValue
                            obligatory
                        />
                    </Grid>
                    <Grid size={2} paddingTop={1}>
                        <Checkbox
                            label={i18n.historic}
                            checked={real}
                            onChange={(value) => onChange({ real: value })}
                            disabled={stationType !== STATION_TYPE_CONSTANT.PLUVIOMETRY}
                        />
                    </Grid>
                    <Grid size={4}>
                        <NumberField
                            title={i18n.coeffHisto}
                            value={coeffReal}
                            onChange={(value) => onChange({ coeffReal: value })}
                            disabled={!real || stationType !== STATION_TYPE_CONSTANT.PLUVIOMETRY}
                            floatValue
                            min={0}
                            max={1}
                        />
                    </Grid>
                    <Grid size={2} paddingTop={1}>
                        <Checkbox
                            label={i18n.scenario}
                            checked={previ}
                            onChange={(value) => onChange({ previ: value })}
                            disabled={stationType !== STATION_TYPE_CONSTANT.PLUVIOMETRY}
                        />
                    </Grid>
                    <Grid size={4}>
                        <NumberField
                            title={i18n.coeffScena}
                            value={coeffPrevi}
                            onChange={(value) => onChange({ coeffPrevi: value })}
                            disabled={!previ || stationType !== STATION_TYPE_CONSTANT.PLUVIOMETRY}
                            floatValue
                            min={0}
                            max={1}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={validUpdate} variant='contained' color='primary'>
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

VolumesManagementUnitDialog.propTypes = {
    linkStationToUpdate: PropTypes.instanceOf(DtoManagementUnitStationLink),
    openDialog: PropTypes.bool,
    onChange: PropTypes.func,
    validUpdate: PropTypes.func,
    closeDialog: PropTypes.func,
}

export default VolumesManagementUnitDialog